import React from "react";
import { Accordion } from "semantic-ui-react";

export default function AboutComponent() {
  const panels = [
    {
      key: "about",
      title: {
        content: "About",
      },
      content: {
        content: (
          <div class="about">
            <strong>History of China (中国通史)</strong>
            <br />
            <strong>Auto-Translation Project</strong>
            <p>
              By{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.yifanchen.io/posts/20201004_history_of_china/"
              >
                Yifan Chen
              </a>
              <br />
              <i>Build 84</i>
            </p>
          </div>
        ),
      },
    },
  ];

  return <Accordion panels={panels} />;
}
